/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Planned7Inputs */

const en__field_enum_planned7 = /** @type {(inputs: _Field_Enum_Planned7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planned`)
};

const de__field_enum_planned7 = /** @type {(inputs: _Field_Enum_Planned7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geplant`)
};

/**
* | output |
* | --- |
* | "Planned" |
*
* @param {_Field_Enum_Planned7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_planned7 = /** @type {((inputs?: _Field_Enum_Planned7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Planned7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_planned7(inputs)
	return de__field_enum_planned7(inputs)
});
export { _field_enum_planned7 as "_field_enum_PLANNED" }